import React, { useMemo } from 'react';
import meetingState from '../../../../../../../data/constants/meetingState';
import { isUpcomingSession } from '../../../../../../../data/filters/scheduleFilters';
import { useActiveParticipantsInSession } from '../../../../../../../data/hooks/participant/useActiveParticipantsInSession';
import { useMeetingRoute, useScheduleSessionRoute } from '../../../../../../../data/hooks/routingHooks';
import Link from '../../../../../../elements/Link';
import MeetingName from '../../../../../../elements/MeetingName';
import MeetingStateIcon from '../../../../../../elements/MeetingStateIcon';
import CountdownTo from '../CountdownTo';
import WaitingRoomItem from '../WaitingRoomItem';
import Location from '../../../../../../elements/Location';
import styles from './NextItem.module.scss';

const NextItem = (props) => {
    const { className = '', event, item, previous, formatTime } = props,
        activeParticipants = useActiveParticipantsInSession(event.id, item.id),
        onlineParticipants = useMemo(() => activeParticipants.filter((p) => p.last_login), [activeParticipants]),
        showCountdown = (!previous || !isUpcomingSession(previous)) && isUpcomingSession(item),
        targetLink = item.invited ? useMeetingRoute(event.id, item.id) : useScheduleSessionRoute(event.id, item.id),
        showState = item.invited && item._state === meetingState.PENDING;

    return (
        <div className={className}>
            {showCountdown ? <CountdownTo item={item} /> : null}
            <div className="p-relative">
                <Link className={styles.layout} href={targetLink}>
                    <table className="layout">
                        <tbody>
                            <tr>
                                <td className="text name" style={{ width: '5em' }}>
                                    {formatTime(item.start_local)}
                                </td>
                                <td className="text name">{item.name || (item.invited ? <MeetingName meeting={item} /> : '')}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <Location className={styles.location}>{item.location?.name ?? item.location}</Location>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {showState ? <MeetingStateIcon event={event} meeting={item} invite={item._myInvite} /> : null}
                </Link>
                {!showState ? <WaitingRoomItem color={event.settings.primary_color} eventId={event.id} nextProgramItem={item} activeParticipants={onlineParticipants} /> : null}
            </div>
        </div>
    );
};

export default NextItem;
